import "./ApplicationReceivedModal.scss";

import { FC } from "react";

import SpinnerCheck, { SPINNER_ANIMATION_DURATION } from "components/SpinnerCheck/SpinnerCheck";
import Text from "components/Text/Text";
import { IModalProps } from "config/init/providers/ModalsProvider";
import { Layout, useTranslation } from "modules";

import { delay } from "lodash-es";

const ApplicationReceivedModal: FC<IModalProps> = ({ closeModal, context, data }) => {
  const { t } = useTranslation();

  const onInitialRender = () => {
    const callback = () => {
      closeModal();
      context?.callbacks?.onClose && context?.callbacks?.onClose();
    };
    const closeAfterTimer = delay(callback, SPINNER_ANIMATION_DURATION);
    return () => clearTimeout(closeAfterTimer);
  };

  const content = {
    onInitialRender,
  };

  return (
    <Layout as="ModalStatusLayout" className="application-received-modal" content={content}>
      <div className="application-received-modal__content">
        <SpinnerCheck />
        <Text
          className="application-received-modal__label"
          tag="l1-label"
          text={
            (data?.text as string) || t("application-received-modal.label", "Application received")
          }
        />
      </div>
    </Layout>
  );
};

export default ApplicationReceivedModal;
